import {forwardRef} from 'react';

import {SizeTokenValue} from 'common';

import {SVG} from './SVG';

import type {IconComponent} from 'icons/types';

const largeIcon = (
  <path d="M15.5 14H14.71L14.43 13.73C15.63 12.33 16.25 10.42 15.91 8.39C15.44 5.61 13.12 3.39 10.32 3.05C6.09005 2.53 2.53005 6.09 3.05005 10.32C3.39005 13.12 5.61005 15.44 8.39005 15.91C10.42 16.25 12.33 15.63 13.73 14.43L14 14.71V15.5L18.25 19.75C18.66 20.16 19.33 20.16 19.74 19.75C20.15 19.34 20.15 18.67 19.74 18.26L15.5 14ZM9.50005 14C7.01005 14 5.00005 11.99 5.00005 9.5C5.00005 7.01 7.01005 5 9.50005 5C11.99 5 14 7.01 14 9.5C14 11.99 11.99 14 9.50005 14Z" />
);

const smallIcon = (
  <path
    fillRule="evenodd"
    clipRule="evenodd"
    d="M3.06506 6.50006C3.06506 4.60296 4.60296 3.06506 6.50006 3.06506C8.39716 3.06506 9.93506 4.60296 9.93506 6.50006C9.93506 8.39716 8.39716 9.93506 6.50006 9.93506C4.60296 9.93506 3.06506 8.39716 3.06506 6.50006ZM6.50006 1.93506C3.97888 1.93506 1.93506 3.97888 1.93506 6.50006C1.93506 9.02124 3.97888 11.0651 6.50006 11.0651C7.55702 11.0651 8.53007 10.7058 9.30381 10.1028L12.6005 13.3996C12.8212 13.6202 13.1789 13.6202 13.3996 13.3996C13.6202 13.1789 13.6202 12.8212 13.3996 12.6005L10.1028 9.30381C10.7058 8.53007 11.0651 7.55702 11.0651 6.50006C11.0651 3.97888 9.02124 1.93506 6.50006 1.93506Z"
  />
);

export const SearchIcon: IconComponent = forwardRef((props, ref) => {
  const {size} = props;

  return (
    <SVG ref={ref} name="Search" {...props}>
      {!size || size === SizeTokenValue.Large || size === SizeTokenValue.Medium ? largeIcon : smallIcon}
    </SVG>
  );
});
